module.exports = __webpack_public_path__ + "static/fastback-f9ba2890ca001c8014ecbda8cbdf402f.png";